import axiosInstance from '../service/AxiosInstance';

/**
 * Utility function to track page visits
 * @param {string} pageUrl - The URL of the page being visited
 * @returns {Promise<void>}
 */
export const trackPageVisit = async (pageUrl) => {
  try {
    const sessionId = sessionStorage.getItem('session_id');
    
    // Only track if we have a valid session_id
    if (!sessionId) {
      return;
    }

    // Get last tracked URL
    const lastTrackedUrl = sessionStorage.getItem('lastTrackedUrl');
    
    // Check if this is a page refresh (same URL as last tracked)
    if (lastTrackedUrl === pageUrl) {
      return; // Skip refresh tracking
    }

    // Update last tracked URL
    sessionStorage.setItem('lastTrackedUrl', pageUrl);

    const payload = {
      page_visited_url: pageUrl,
      session_id: sessionId
    };

    await axiosInstance.post('/track-page-visit', payload);
    
  } catch (error) {
    // Don't throw error to avoid breaking the user experience
  }
};

